import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { MapCoordinateDto } from '../../../shared/modules/shared/dtos/map-coordinate.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { LocationTypeEnum } from '../enums/location-type.enum';

/**
 * Create location DTO
 */
export class CreateLocationDto {
  color?: string | null;
  notes?: string | null;
  type!: LocationTypeEnum;
  name!: string;
  areaId!: number;
  isPickUp?: boolean | null;
  isDropOff?: boolean | null;
  isPrivate?: boolean | null;
  contact!: TenantContactDto;
  gpsCoordinates!: MapCoordinateDto;
  tags?: TagDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
